@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.muhammadnoman.photocraft.pages.IndexPage as _com_muhammadnoman_photocraft_pages_IndexPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "PhotoCraft"))
    BasePath.set("/kobweb-photocraft/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_muhammadnoman_photocraft_pages_IndexPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("app-shell", com.muhammadnoman.photocraft.styles.AppShellStyle)
        ctx.theme.registerStyle("app-body", com.muhammadnoman.photocraft.styles.AppBodyStyle)
        ctx.theme.registerStyle("header", com.muhammadnoman.photocraft.styles.HeaderStyle)
        ctx.theme.registerStyle("header-title-input", com.muhammadnoman.photocraft.styles.HeaderTitleInputStyle)
        ctx.theme.registerStyle("header-icon-btn", com.muhammadnoman.photocraft.styles.HeaderIconBtnStyle)
        ctx.theme.registerStyle("sidebar", com.muhammadnoman.photocraft.styles.SidebarStyle)
        ctx.theme.registerStyle("sidebar-item", com.muhammadnoman.photocraft.styles.SidebarItemStyle)
        ctx.theme.registerStyle("properties-panel", com.muhammadnoman.photocraft.styles.PropertiesPanelStyle)
        ctx.theme.registerStyle("canvas-area", com.muhammadnoman.photocraft.styles.CanvasAreaStyle)
        ctx.theme.registerStyle("panel-header", com.muhammadnoman.photocraft.styles.PanelHeaderStyle)
        ctx.theme.registerStyle("panel-content", com.muhammadnoman.photocraft.styles.PanelContentStyle)
        ctx.theme.registerStyle("panel-title", com.muhammadnoman.photocraft.styles.PanelTitleStyle)
        ctx.theme.registerStyle("section-label", com.muhammadnoman.photocraft.styles.SectionLabelStyle)
        ctx.theme.registerStyle("panel-divider", com.muhammadnoman.photocraft.styles.PanelDividerStyle)
        ctx.theme.registerStyle("primary-btn", com.muhammadnoman.photocraft.styles.PrimaryBtnStyle)
        ctx.theme.registerStyle("secondary-btn", com.muhammadnoman.photocraft.styles.SecondaryBtnStyle)
        ctx.theme.registerStyle("danger-btn", com.muhammadnoman.photocraft.styles.DangerBtnStyle)
        ctx.theme.registerStyle("icon-btn", com.muhammadnoman.photocraft.styles.IconBtnStyle)
        ctx.theme.registerStyle("toggle-btn", com.muhammadnoman.photocraft.styles.ToggleBtnStyle)
        ctx.theme.registerStyle("slider-label-row", com.muhammadnoman.photocraft.styles.SliderLabelRowStyle)
        ctx.theme.registerStyle("slider-value-badge", com.muhammadnoman.photocraft.styles.SliderValueBadgeStyle)
        ctx.theme.registerStyle("filter-card", com.muhammadnoman.photocraft.styles.FilterCardStyle)
        ctx.theme.registerStyle("layer-row", com.muhammadnoman.photocraft.styles.LayerRowStyle)
        ctx.theme.registerStyle("shape-btn", com.muhammadnoman.photocraft.styles.ShapeBtnStyle)
        ctx.theme.registerStyle("sticker-card", com.muhammadnoman.photocraft.styles.StickerCardStyle)
        ctx.theme.registerStyle("drop-zone", com.muhammadnoman.photocraft.styles.DropZoneStyle)
        ctx.theme.registerStyle("aspect-btn", com.muhammadnoman.photocraft.styles.AspectBtnStyle)
        ctx.theme.registerStyle("tab-btn", com.muhammadnoman.photocraft.styles.TabBtnStyle)
        com.muhammadnoman.photocraft.styles.initPhotoCraftTheme(ctx)
        com.muhammadnoman.photocraft.styles.initPhotoCraftStyles(ctx)
        com.muhammadnoman.photocraft.initPhotoCraftColorMode(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.muhammadnoman.photocraft.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
